import type { IAnimateConfig } from '@visactor/vrender-core';

export const DefaultMorphingAnimateConfig: IAnimateConfig = {
  duration: 1000,
  easing: 'quadInOut'
};
